import { render, staticRenderFns } from "./IconPiePercentage.vue?vue&type=template&id=18153936&scoped=true&"
import script from "./IconPiePercentage.vue?vue&type=script&lang=ts&"
export * from "./IconPiePercentage.vue?vue&type=script&lang=ts&"
import style0 from "./IconPiePercentage.vue?vue&type=style&index=0&id=18153936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18153936",
  null
  
)

export default component.exports